var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var SurveyEntryMyQol = require('./surveyEntryMyQol.jsx');

var DashboardWithoutDataMyQol = createReactClass({
    mixins: [PureRenderMixin],

    render: function(){
        return (
            <div className={'dashboard-without-data' + (this.props.isEmpty ? ' is-empty' : '')}>
                <div className="content-header-wrapper">
                    <div className="content-header-small content-header row column">
                        <h1>Quality of Life</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="large-6 column">
                        <div className="half-bg"></div>
                    </div>
                    <div className="large-6 column end">
                        <div className="hero-text-block">
                            <h2>Want to improve your <br />overall quality of life?</h2>
                            <p>Completing this survey will generate a report that shows how your symptoms are connected to your emotions.</p>
                            <p>
                                <SurveyEntryMyQol
                                    labelText="Take the Quality of Life Survey"
                                    clickTracking={this.props.clickTracking} />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
});

module.exports = DashboardWithoutDataMyQol;



// WEBPACK FOOTER //
// ./src/common/routes/dashboard/components/layout/dashboardWithoutDataMyQol.jsx